exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.relative {\n    position: relative;\n}\n.modal-body {\n    min-height: 100px;\n    position: relative;\n}\n.row .enrolment:not(:last-child) {\n    margin-bottom: 30px;\n}\n.enrolment-info {\n        display: block;\n}\n", ""]);

// exports
